import { getFormattedDate } from 'lib/common';
import { Icon } from 'components/common/icons';

interface Props {
  inputDate: string;
  omitTime?: boolean;
  showIcons?: boolean;
  text?: string;
}

const FormattedDateWithTime = ({
  inputDate,
  omitTime = false,
  showIcons = false,
  text
}: Props) => {
  const date = getFormattedDate({ date: inputDate });
  const time = getFormattedDate({ date: inputDate, dateFormat: 'HH:mm' });

  return (
    <>
      {text ? text : null}
      {showIcons ? (
        <Icon
          icon={['far', 'calendar-alt']}
          style={{ ...(text ? { marginLeft: 5 } : {}) }}
        />
      ) : null}
      <span style={{ marginLeft: 5 }}>{date}</span>
      {omitTime ? null : (
        <>
          {showIcons ? (
            <Icon icon={['far', 'clock']} style={{ marginLeft: 5 }} />
          ) : null}
          <span style={{ marginLeft: 5 }}>{time}</span>
        </>
      )}
    </>
  );
};

export default FormattedDateWithTime;
